import { useContext } from "react";
import { UserContext } from "../context/user-context";

export const useAuth = () => {
  const context = useContext(UserContext);

  if (!context)
    throw new Error("useAuthContext context must be use inside AuthProvider");

  const { user, dispatchUser } = context;

  const initAuth = (result: any) => {
    dispatchUser({ type: "set", payload: result });
  };

  const resetUser = () => {
    dispatchUser({ type: "reset", payload: null });
  };

  return { user, initAuth, resetUser };
};
